import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only use StrictMode in production to avoid double API calls in development
// StrictMode intentionally double-invokes effects to detect side effects
const AppComponent = process.env.NODE_ENV === 'production' ? (
  <React.StrictMode>
    <App />
  </React.StrictMode>
) : (
  <App />
);

root.render(AppComponent);
